module.exports = __webpack_public_path__ + "img/2.a14b392d.png";